import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { post } from "../../lib/request"

export function normalizeSocialNetworkUsername(value) {
  const trimmed = String(value ?? "").trim()
  if (!trimmed) return ""
  return trimmed.replace(/^@+/, "").trim()
}

/** POST /api/v1/entity-social-network-accounts/validate */
export const validateEntitySocialNetworkAccount = createAsyncThunk(
  "entitySocialNetworkValidate/validate",
  async ({ socialNetworkTypeId, socialNetworkUsername }, { rejectWithValue }) => {
    try {
      const username = normalizeSocialNetworkUsername(socialNetworkUsername)
      if (!username) {
        return rejectWithValue("Enter valid username")
      }
      const typeId = Number(socialNetworkTypeId)
      if (!typeId || Number.isNaN(typeId)) {
        return rejectWithValue("Select a channel")
      }

      const response = await post("entity-social-network-accounts/validate", {
        socialNetworkTypeId: typeId,
        socialNetworkUsername: username,
      })

      const url = String(response?.socialNetworkUrl ?? "").trim()
      if (response?.status === "success" && url) {
        return {
          socialNetworkTypeId: response.socialNetworkTypeId ?? typeId,
          socialNetworkId: response.socialNetworkId ?? null,
          socialNetworkUsername: response.socialNetworkUsername ?? username,
          socialNetworkUrl: url,
          message: response.message ?? "",
        }
      }

      return rejectWithValue(
        response?.message || "Enter valid username",
      )
    } catch (error) {
      return rejectWithValue(error?.message || "Enter valid username")
    }
  },
)

const initialState = {
  loading: false,
  error: null,
  lastResult: null,
}

const entitySocialNetworkValidateSlice = createSlice({
  name: "entitySocialNetworkValidate",
  initialState,
  reducers: {
    clearEntitySocialNetworkValidate: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(validateEntitySocialNetworkAccount.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(validateEntitySocialNetworkAccount.fulfilled, (state, action) => {
        state.loading = false
        state.error = null
        state.lastResult = action.payload
      })
      .addCase(validateEntitySocialNetworkAccount.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload || "Enter valid username"
        state.lastResult = null
      })
  },
})

export const { clearEntitySocialNetworkValidate } = entitySocialNetworkValidateSlice.actions
export default entitySocialNetworkValidateSlice.reducer
